import React from "react";
import { TextInput } from "react-admin";

import { rangeValue } from "../../utils/validation/general";
import { parseDigits } from "../_helpers/parsers";

const DEFAULT_SSCC_EXTENSION_DIGIT = 3;

const validateExtensionDigitRange = rangeValue(0, 9);

export const SSCCExtensionDigitInput = ({ validate, ...props }) => {
	const extraValidators = validate ? [].concat(validate) : [];
	const validators = [validateExtensionDigitRange, ...extraValidators];
	return (
		<TextInput
			parse={(value) => (value ? parseDigits(value).slice(0, 1) : value)}
			inputProps={{
				inputMode: "numeric",
				maxLength: 1,
			}}
			defaultValue={DEFAULT_SSCC_EXTENSION_DIGIT}
			validate={validators}
			{...props}
		/>
	);
};
